<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="onMarkRead">标记已读</el-button>
    </div>
    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-selection="handlerChangeSelection"
      @change-page="handlerPageChange">
      <el-table-column
        slot="filter"
        fixed="left"
        type="selection"
        width="55"/>
      <el-table-column
        slot="action"
        fixed="right"
        label="查看留言"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              plain
              @click="seeWordsDetail(scope.row.content)">查看</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        slot="status"
        fixed="right"
        label="状态"
        align="center">
        <template slot-scope="scope">
          <div>
            <span
              style="color: #67c23a;"
              v-if="scope.row.is_read == 2">已读</span>
            <span
              style="color: #f56c6c;"
              v-else>未读</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="danger"
              plain
              @click="del(scope.row.uuid)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      title="留言"
      :visible.sync="dialogVisible"
      width="30%">
      <div>
        {{ words }}
      </div>
    </el-dialog>
  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  contactList, maskReadContactUs, deleteContactRecord,
} from '@/api/about'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      config: {
        // pagination: true,
        size: 20,
        fields: [
          {
            prop: 'name',
            label: '客户姓名',
          },
          {
            prop: 'sex',
            label: '性别',
          },
          {
            prop: 'mobile',
            label: '电话',
          },
          {
            prop: 'email',
            label: '邮箱',
          },
          {
            prop: 'theme',
            label: '主题',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      selectionData: [],
      pageIndex: 1,
      dialogVisible: false,
      words: '',
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().contactList()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    handlerChangeSelection(data) {
      this.selectionData = data
    },
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().contactList()
    },
    seeWordsDetail(words) {
      this.words = words
      this.dialogVisible = true
    },
    onMarkRead() {
      if (this.selectionData.length < 1) {
        this.$message('请先选中')
        return
      }
      const uuidArr = []
      this.selectionData.forEach((item) => {
        uuidArr.push(item.uuid)
      })
      this.network().maskReadContactUs(uuidArr)
    },
    del(uuid) {
      this.network().deleteContactRecord(uuid)
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        contactList: async () => {
          const { status, data } = await contactList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_num
            this.datasource.data = data.char
          }
        },
        maskReadContactUs: async (data) => {
          const { status } = await maskReadContactUs({
            uuid: data,
          })
          if (status === 200) {
            this.network().contactList()
          }
        },
        deleteContactRecord: async (data) => {
          const { status } = await deleteContactRecord(data)
          if (status === 200) {
            this.$notify({ title: '提示', message: '删除成功' })
            this.network().contactList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>

.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/about/contact-list.vue